<template>
  <product
    :product-logo="productLogo"
    :product-cover="productCover"
    :product-brief="productBrief"
    :carousel-items-no="1"
    :carousel-images="carouselImages"
  >
    <p>
      Our partnership had started back in 2018 with a simple "few days"
      job. However, Lubomir, the product founder had planned a lot more
      for the platform. At first, my job was to create a simple popup
      that subscribed you to a product's newsletter. After the job was
      finished successfully - We started a long-term partnership.
    </p>
    <p>
      Since then we have:
      <ul>
        <li>Built an author module</li>
        <li>Added rating/followers system for profiles</li>
        <li>Created an advanced content editor for authors</li>
        <li>Built website-agnostic article importer (for authors to be able to
          bring in their content from other platforms)</li>
        <li>Extended the platform with E-Books, featuring an online E-Book reader and importer</li>
      </ul>
    </p>
    <p>
      We had quite a successful launch. And now, the product keeps growing
      and developing its community. Lubo was so happy with the
      collaboration we had, that he offered me to join the team as a
      Co-Founder, an opportunity, which I've proudly accepted. So now
      we're keeping up the good work as one team.
    </p>
    <template v-slot:footer>
      <div class="col-12 mt-3 py-2 next-btn">
        <router-link :to="{ name: 'one-app' }">
          <span>Next &mdash; ONE App</span>
          <font-awesome-icon icon="arrow-right" size="3x" />
        </router-link>
      </div>
    </template>
  </product>
</template>

<script>
import Product from '@/components/product/Product'
export default {
  components: { Product },
  data() {
    return {
      productLogo: require('@/assets/img/products/Parrity.png'),
      productBrief: 'Open tutorials, courses, and how to`s made by the brightest business minds of our time',
      carouselImages: [
        require('@/assets/img/products/parr/1.png'),
        require('@/assets/img/products/parr/2.png'),
        require('@/assets/img/products/parr/4.png'),
        require('@/assets/img/products/parr/3.png'),
      ],
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/components/product/details";

section.main {
  background-image: linear-gradient(#d4d6d74f, #a0ced537), url('~@/assets/img/products/parr/cover.jpg');
}
</style>
